module.exports = __webpack_public_path__ + "static/media/drinking.a3ae3911.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/lsc/drinking.svg
// module id = 437
// module chunks = 0